"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.number.constructor");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerPDFRendererPage = exports.PDFRendererPage = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _element = require("@onviobr/element");

var _pdfjsDist = require("pdfjs-dist");

var _performance = require("./utils/performance");

var _async = require("./utils/async");

var _pageCache = require("./utils/page-cache");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n      <style>\n        :host {\n          margin-bottom: 15px;\n          position: relative;\n        }\n\n        :host > * {\n          position: absolute;\n        }\n      </style>\n      <canvas></canvas>\n      <svg></svg>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var pagesCache = new _pageCache.Cache(500, function (page) {
  var _context, _context2, _context3, _context4;

  return (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(page.documentVerId)).call(_context4, page.documentFingerprint)).call(_context3, page.pageNumber)).call(_context2, page.documentName)).call(_context, page.creationDate);
});

var PDFRendererPage = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(PDFRendererPage, _BlueElement);

  var _super = (0, _createSuper2.default)(PDFRendererPage);

  (0, _createClass2.default)(PDFRendererPage, null, [{
    key: "is",
    get: function get() {
      return 'pdf-renderer-page';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        page: {
          type: Object,
          attribute: false,
          reflect: false
        },
        zoom: {
          type: Number,
          attribute: true,
          reflect: true
        },
        disableTextLayer: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        markUpdated: {
          type: Boolean,
          attribute: false,
          reflect: false
        }
      };
    }
  }]);

  function PDFRendererPage() {
    var _this;

    (0, _classCallCheck2.default)(this, PDFRendererPage);
    _this = _super.call(this);
    _this.disableTextLayer = false;
    _this.wasUpdated = false;
    _this.frame = void 0;
    (0, _performance.timestamp)('PDF Renderer Page - new');
    _this.frame = (0, _async.frames)();
    return _this;
  }

  (0, _createClass2.default)(PDFRendererPage, [{
    key: "restoreFromCache",
    value: function restoreFromCache() {
      var cache = pagesCache.get(this.page, this.zoom);

      if (cache) {
        this.replaceDOM(cache.canvas, cache.svg, cache.viewport);
      }
    }
  }, {
    key: "saveToCache",
    value: function saveToCache() {
      pagesCache.set(this.page, this.zoom, {
        canvas: this.canvas,
        svg: this.textSVG,
        viewport: this.viewport
      });
    }
  }, {
    key: "replaceDOM",
    value: function replaceDOM(canvas, svg, viewport) {
      var _context5, _context6;

      this.canvas = canvas;
      this.textSVG = svg;
      var root = this.shadowRoot || this;
      var currentCanvas = (0, _find.default)(_context5 = (0, _toConsumableArray2.default)(root.children)).call(_context5, function (e) {
        return e.nodeName === 'CANVAS';
      });
      var currentSvg = (0, _find.default)(_context6 = (0, _toConsumableArray2.default)(root.children)).call(_context6, function (e) {
        return e.nodeName === 'svg';
      });

      if (currentCanvas) {
        root.replaceChild(this.canvas, currentCanvas);
      }

      if (currentSvg) {
        root.replaceChild(this.textSVG, currentSvg);
      }

      this.context = this.canvas.getContext('2d');
      this.viewport = viewport;
      this.resizeRoot();
    }
  }, {
    key: "blackDOM",
    value: function blackDOM(viewport) {
      var canvas = document.createElement('canvas');
      var textSVG = document.createElementNS('http://www.w3.org/2000/svg', "svg");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      return {
        canvas: canvas,
        textSVG: textSVG
      };
    }
  }, {
    key: "resizeRoot",
    value: function resizeRoot() {
      if (!this.viewport) {
        return;
      }

      this.style.height = "".concat(this.viewport.height, "px");
      this.style.width = "".concat(this.viewport.width, "px");
    }
  }, {
    key: "cleanCanvas",
    value: function () {
      var _cleanCanvas = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.frame('cleanCanvas');

              case 2:
                if (!(!this.canvas || !this.context)) {
                  _context7.next = 4;
                  break;
                }

                return _context7.abrupt("return");

              case 4:
                (0, _performance.timestamp)('PDF Renderer Page - clean canvas');
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
                this.canvas.height = this.viewport.height;
                this.canvas.width = this.viewport.width;

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee, this);
      }));

      function cleanCanvas() {
        return _cleanCanvas.apply(this, arguments);
      }

      return cleanCanvas;
    }()
  }, {
    key: "createCanvasContent",
    value: function () {
      var _createCanvasContent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var viewport, _this$blackDOM, canvas, textSVG, context;

        return _regenerator.default.wrap(function _callee2$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.task) {
                  this.task.cancel();
                }

                viewport = this.page.getViewport({
                  scale: this.zoom
                });
                _this$blackDOM = this.blackDOM(viewport), canvas = _this$blackDOM.canvas, textSVG = _this$blackDOM.textSVG;
                context = canvas.getContext('2d');
                this.task = this.page.render({
                  canvasContext: context,
                  enableWebGL: true,
                  viewport: viewport
                });
                _context8.next = 7;
                return this.task.promise;

              case 7:
                this.replaceDOM(canvas, textSVG, viewport);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee2, this);
      }));

      function createCanvasContent() {
        return _createCanvasContent.apply(this, arguments);
      }

      return createCanvasContent;
    }()
  }, {
    key: "printPage",
    value: function () {
      var _printPage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!pagesCache.has(this.page, this.zoom)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return", this.restoreFromCache());

              case 2:
                _context9.next = 4;
                return this.createCanvasContent();

              case 4:
                _context9.next = 6;
                return this.createSVGText();

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee3, this);
      }));

      function printPage() {
        return _printPage.apply(this, arguments);
      }

      return printPage;
    }()
  }, {
    key: "renderPage",
    value: function () {
      var _renderPage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _context10;

        return _regenerator.default.wrap(function _callee4$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.frame('renderPage');

              case 3:
                _context11.next = 5;
                return this.printPage();

              case 5:
                this.saveToCache();
                _context11.next = 13;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                if (!(0, _includes.default)(_context10 = _context11.t0.message).call(_context10, 'Rendering cancelled')) {
                  _context11.next = 12;
                  break;
                }

                return _context11.abrupt("return", _context11.t0);

              case 12:
                throw _context11.t0;

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function renderPage() {
        return _renderPage.apply(this, arguments);
      }

      return renderPage;
    }()
  }, {
    key: "createSVGText",
    value: function () {
      var _createSVGText = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var textContent;
        return _regenerator.default.wrap(function _callee5$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!this.disableTextLayer) {
                  _context12.next = 2;
                  break;
                }

                return _context12.abrupt("return");

              case 2:
                _context12.next = 4;
                return this.frame('createSVGText');

              case 4:
                (0, _performance.timestamp)('PDF Renderer Page - Start SVG Text generation');
                _context12.next = 7;
                return this.cleanTextSVG();

              case 7:
                _context12.next = 9;
                return this.page.getTextContent({
                  normalizeWhitespace: true,
                  disableCombineTextItems: false
                });

              case 9:
                textContent = _context12.sent;
                this.createSVGTextNode(textContent);
                (0, _performance.timestamp)('PDF Renderer Page - End SVG Text generation');

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee5, this);
      }));

      function createSVGText() {
        return _createSVGText.apply(this, arguments);
      }

      return createSVGText;
    }()
  }, {
    key: "createSVGTextNode",
    value: function createSVGTextNode(textContent) {
      var _context13,
          _this2 = this;

      this.textSVG.setAttribute('width', "".concat(this.viewport.width, "px"));
      this.textSVG.setAttribute('height', "".concat(this.viewport.height, "px"));
      this.textSVG.setAttribute('font-size', '1');
      (0, _map.default)(_context13 = textContent.items).call(_context13, function (textItem) {
        return (_this2.textSVG.append || _this2.textSVG.appendChild).call(_this2.textSVG, _this2.createSVGTextItem(textItem, textContent));
      });
    }
  }, {
    key: "createSVGTextItem",
    value: function createSVGTextItem(textItem, textContent) {
      var tx = _pdfjsDist.Util.transform(_pdfjsDist.Util.transform(this.viewport.transform, textItem.transform), [1, 0, 0, -1, 0, 0]);

      var style = textContent.styles[textItem.fontName];
      var text = document.createElementNS('http://www.w3.org/2000/svg', "svg:text");
      text.setAttribute('transform', "matrix(".concat(tx.join(' '), ")"));
      text.setAttribute('font-family', style.fontFamily);
      text.setAttribute('fill', 'transparent');
      text.textContent = textItem.str;
      return text;
    }
  }, {
    key: "cleanTextSVG",
    value: function () {
      var _cleanTextSVG = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.frame('cleanTextSVG');

              case 2:
                (0, _performance.timestamp)('PDF Renderer Page - clean text SVG');

                while (this.textSVG.firstChild) {
                  this.textSVG.removeChild(this.textSVG.firstChild);
                }

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee6, this);
      }));

      function cleanTextSVG() {
        return _cleanTextSVG.apply(this, arguments);
      }

      return cleanTextSVG;
    }()
  }, {
    key: "dispatchError",
    value: function dispatchError(error) {
      this.dispatchEvent(new CustomEvent('error', {
        detail: error
      }));
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(changedProps) {
      var _this3 = this;

      if (this._shouldUpdatePage(changedProps)) {
        this.renderPage().catch(function (error) {
          return _this3.dispatchError(error);
        });
      }

      return !this.wasUpdated;
    }
  }, {
    key: "updated",
    value: function updated() {
      this.wasUpdated = true;
    }
  }, {
    key: "render",
    value: function render() {
      (0, _performance.timestamp)('PDF Renderer Page - render');
      return this.html(_templateObject());
    }
  }, {
    key: "_shouldUpdatePage",
    value: function _shouldUpdatePage(changedProps) {
      var pageChanged = changedProps.has('page') && this.page !== undefined && this.page !== changedProps.get('page');
      var zoomChanged = changedProps.has('zoom') && this.zoom !== undefined && this.zoom !== changedProps.get('zoom');
      return pageChanged || zoomChanged;
    }
  }]);
  return PDFRendererPage;
}(_element.BlueElement);

exports.PDFRendererPage = PDFRendererPage;

var registerPDFRendererPage = function registerPDFRendererPage() {
  return (0, _element.register)(PDFRendererPage);
};

exports.registerPDFRendererPage = registerPDFRendererPage;
